import React from 'react';

import { ModalContext, ModalType } from './ModalContext';

type State = {
  isOpen: boolean;
  component: ModalType<Object | undefined> | null;
  forceRenderKey: number;
  customProps?: Object;
};

export class ModalProvider extends React.Component<{}, State> {
  state: State = {
    isOpen: false,
    component: null,
    forceRenderKey: 0,
    customProps: undefined,
  };

  openModal = (
    component: ModalType<Object | undefined>,
    customProps?: Object,
  ) => {
    this.setState(({ forceRenderKey }) => ({
      isOpen: true,
      component,
      forceRenderKey: forceRenderKey + 1,
      customProps,
    }));
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { children } = this.props;
    const {
      component: Component,
      isOpen,
      forceRenderKey,
      customProps,
    } = this.state;

    return (
      <ModalContext.Provider value={{ openModal: this.openModal }}>
        <>
          {children}
          {Component !== null && (
            <Component
              isOpen={isOpen}
              closeModal={this.closeModal}
              onRequestClose={this.closeModal}
              key={forceRenderKey}
              customProps={customProps}
            />
          )}
        </>
      </ModalContext.Provider>
    );
  }
}
